const formatDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const getReportPeriod = (preset, now = new Date()) => {
    const year = now.getFullYear();
    const month = now.getMonth();
    if (preset === "previous_month") {
        const previousMonthStart = new Date(year, month - 1, 1);
        const previousMonthEnd = new Date(year, month, 0);
        return { periodFrom: formatDate(previousMonthStart), periodTo: formatDate(previousMonthEnd) };
    }
    return { periodFrom: formatDate(new Date(year, month, 1)), periodTo: formatDate(now) };
};

export const previousMonthValue = (now = new Date()) => {
    const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return `${previousMonth.getFullYear()}-${String(previousMonth.getMonth() + 1).padStart(2, "0")}`;
};
